import styled from 'styled-components';
export const Buttons = styled.div<{ isColumn?: boolean }>`
  padding: 8px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: ${p => p.isColumn ? '' : '100%'};
  border-top: ${p => p.isColumn ? '' : '1px solid #eee'};
  > *:not(:last-child) {
    margin-right: 8px;
  }
`;
